//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Form from 'vform'
import { mapGetters } from 'vuex'
import dayjs from '~/modules/dayjs'
import veeValidate from '~/mixins/veeValidate'
import { vLog } from '~/utils/vLog'
import VueToastMixin from '~/mixins/plugins/vue-toastification'
import GTM from '~/utils/classes/Gtm'
import { isWindow } from '~/plugins/v-js'
import { debounce, isObject } from '~/utils/v'
import { LocalStore } from '~/utils/localStore'


import searchInput from "~/mixins/search/search-input";

const localSt = new LocalStore()

export default {
  name: 'RequestOfferForm',
  mixins: [veeValidate, VueToastMixin, searchInput],
  props: {
    boat: {
      type: Object,
      default: () => {}
    },
    marina: {
      type: [Object, String],
      default: () => {}
    },
    startDate: {
      type: Date,
      default: () => null //dayjs().day(6).add(7, 'd').toDate()
    },
    endDate: {
      type: Date,
      default: () => null // dayjs().day(6).add(14, 'd').toDate()
    },
    minDate: {
      type: Date,
      default: () => new Date()
    },
    maxDate: {
      type: Date,
      default: () => dayjs().add(1, 'y').toDate()
    },
    checkInDate: {
      type: String,
      default: ''
    },
    checkOutDate: {
      type: String,
      default: ''
    },
    blockedDates: {
      type: Array,
      default: () => []
    },
    guests: {
      type: Number,
      default: 1
    },
    excludeFields: {
      type: Array,
      default: () => ['flexibility']
    },
    skipAvailability: {
      type: Boolean,
      default: true
    },
    buttonText: {
      type: String,
      default: 'request-offer'
    },
    addNotes: {
      type: Object,
      default: () => {}
    },
    charterType: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      rawInput: '',
      input: '',
      budgets: [
        { id: 1, name: '0 - 1000' },
        { id: 2, name: '1000 - 3000' },
        { id: 3, name: '3000 - 5000' },
        { id: 4, name: '5000 - 7000' },
        { id: 5, name: '7000 - 10000' },
        { id: 6, name: '> 10000' }
      ],
      form: new Form({
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        charter_type: '',
        budget: '',
        boat_type: '',
        planing_stage: '',
        location: '',
        guests: '',
        comment: '',
        date: [],
        skip_availability: false
      }),
      date: {
        start: null, //dayjs().day(6).add(7, 'd').toDate()
        end: null, //dayjs().day(6).add(14, 'd').toDate()
        min: null,
        max: null
      },
      formRules: {
        first_name: 'required',
        last_name: 'required',
        email: 'required|email',
        charter_type: 'required',
        budget: 'required',
        boat_type: 'required',
        location: 'required',
        planing_stage: 'required',
        guests: 'required|min_value:1',
        date: '',
        comment: ''
      },
      busy: {
        form: false
      },
      gtm: new GTM(this.$gtm)
    }
  },
  async fetch (ctx) {
    await ctx.store.dispatch('data/getBoatFormData', { type: null, data: { only: ['FetchBoatTypes'] } })
  },
  created () {
    this.$store.dispatch('search/getAutocompletePopular')
    if (![null, undefined].includes(this.skipAvailability)) {
      this.form.skip_availability = this.skipAvailability
    }
    if (this.guests) {
      this.form.guests = this.guests
    }
    if (this.startDate) {
      this.date.start = this.startDate
    }
    if (this.marina && this.excludeFields.includes('location')) {
      this.form.location = this.marina.name ? this.marina.name : this.marina
    }
    if (this.endDate) {
      this.date.end = this.endDate
    }
    if (this.charterType) {
      this.form.charter_type = this.charterType
    }
    if (this.user) {
      this.form.first_name = this.user.first_name
      this.form.last_name = this.user.last_name
      this.form.email = this.user.email
      this.form.phone_number = this.user.phone
    }
  },
  computed: {
    ...mapGetters({
      locale: 'lang/locale',
      user: 'auth/user',
      ipInfo: 'ip',
      GCLID: 'auth/GCLID',
      GBRAID: 'auth/GBRAID',
      UTM: 'auth/UTM',
      defaultLocale: 'lang/defaultLocale',
      boatFormData: 'data/boatFormData',
      autocomplete: 'search/autocomplete'
    }),
    planingStages () {
      return [
        { id: 'exploring-options', name: this.$t('exploring-options') },
        { id: 'almost-ready-to-book', name: this.$t('almost-ready-to-book') },
        { id: 'ready-to-confirm-booking', name: this.$t('ready-to-confirm-booking') }
      ]
    },
    getBoatTypes () {
      return this.$store.state.search.staticBoatTypes.map((t) => {
        const result = { ...t }
        if (result.id === 9999) {
          result.name = 'other'
        }
        return {
          ...result,
          name: result.translate ? this.$t(result.name.toLowerCase()) : result.name,
          untranslatedName: result.name
        }
      }).sort((a, b) => {
        return a.id - b.id || a.name.localeCompare(b.name)
      })
    },
    getFlexibilityOptions () {
      return [
        { id: 'on_the_day', name: this.$t('on-the-day') },
        { id: 'in_the_week', name: this.$t('in-the-week') },
        { id: 'one_week_around', name: this.$t('a-week-before-or-after') },
        { id: 'two_week_around', name: this.$t('two-weeks-before-or-after') },
        { id: 'in_the_month', name: this.$t('in-the-month') }
      ]
    },
    getCharterTypes () {
      return this.boatFormData?.charterTypes?.map((g) => {
        const name = g.name[this.locale] || g.name[this.defaultLocale]
        return {
          id: g.id,
          name
        }
      })
    },
    getCharterTypesDefault () {
      return this.boatFormData?.charterTypes?.map((g) => {
        const name = g.name[this.defaultLocale] || g.name[this.locale]
        return {
          id: g.id,
          name
        }
      })
    }
  },
  watch: {
    'form.phone_number' () {
      this.form.errors.clear('phone_number')
    },
    'busy.form' () {
      this.$nuxt.$emit('request-modal__loading', { state: this.busy.form })
    }
  },
  beforeCreate () {
    this.$nuxt.$emit('request-modal__loading', { state: false })
  },
  mounted() {
    this.setPhoneActiveCountry()
  },
  methods: {
    setFromList (th) {
      const list_ = th.list_
      if (!list_?.curId && list_?.list?.length && list_.list[0]) {
        const item = list_.list[0]
        const data = item
        this.$store.commit('search/SET_BAR', { condition: 'current', data })
        this.$store.commit('search/SET_LOCATION', data)
        // setFromList({ id: item.id, name: item.raw, url: item.slug })
        th.value = item.raw
        list_.value = item.raw
      }
    },
    setLocation(data) {
      if (this.autocomplete.data.length) {
        const loc = this.autocomplete.data.find(l => l.id === data.id)
        this.form.location = loc?.title_en ?? loc?.name
        return
      }
      if (this.autocomplete.popular.length) {
        const loc = this.autocomplete.popular.find(l => l.id === data.id)
        this.form.location =  loc?.title_en ?? loc?.name
        return
      }
      this.form.location = data.name
    },
    search: debounce(async function (e) {
      if (
        !this.rawInput?.name ||
        this.rawInput?.name === this.$store.state.search?.autocomplete?.value
      ) {
        this.$store.commit('search/SET_AUTOCOMPLETE', { data: [], loading: false })
        return
      }
      await this.$store.dispatch('search/getAutocomplete', this.rawInput?.name)
    }, 300),
    inputClickHandler (e) {
      this.$modal.show('search-destination-input-modal', { form: this.form })
    },
    formatDate (date, format) {
      let m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      let d = date.getDate()
      d = d < 10 ? '0' + d : d
      return format.replace('YYYY', date.getFullYear()).replace('MM', m).replace('DD', d)
    },
    disabledBeforeToday (date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0))
    },
    setPhoneActiveCountry (obj = null) {
      if (this.$route.name !== 'boat-view') {
        const dialCode = obj?.dialCode
        if (dialCode) {
          this.formRules.phone_number = `required|phone:${dialCode}`
        } else {
          this.formRules.phone_number = 'required|phone'
        }
      }
    },
    async save () {
      this.form.errors.clear();
      this.busy.form = true
      const form = this.form.data()
      if (['request-offer', 'flotillas', 'flotilla page', 'flotilla location'].includes(this.$route.name) && !form.date[0]) {
        this.form.errors.set({'date': ''})
        this.busy.form = false

        return
      }
      if (this.$route.name === 'request-offer' && !form.location) {
        this.form.errors.set({'location': ''})
        this.busy.form = false

        return
      }
      const eventData = this.boat ? { ...this.boat, email: form.email } : null
      const gtm = {
        clickMethod: 'generateLeadClick',
        method: 'generateLead',
        data: eventData
      }
      if (!gtm.data) {
        let from = 'empty'
        switch (this.$route.name) {
          case 'flotillas':
          case 'flotilla page':
          case 'flotilla location':
            from = 'Flotillas'
            break
          case 'request-offer':
            from = 'Request offer page'
            break
          default:
            from = 'empty'
            break
        }

        gtm.clickMethod = 'requestOfferSentClick'
        gtm.method = 'requestOfferSent'
        gtm.data = {
          name: this.marina || 'Flotillas page',
          email: form.email,
          from
        }
      }

      this.gtm[gtm.clickMethod](gtm.data)

      const isValid = await this.$refs?.formObs?.validate()
      if (!isValid) {
        if (['request-offer'].includes(this.$route.name)) {
          this.$scrollTo({ y: 0 })
        }
        this.busy.form = false
        return
      }

      let notes = ''
      const gclid = localSt.getDayValue('gclid')
      const gbraid = localSt.getDayValue('gbraid')

      if (isObject(this.addNotes)) {
        try {
          for (const [key, value] of Object.entries(this.addNotes)) {
            notes += `${key}: ${value}, `
          }
        } catch (e) {
          console.log(e)
        }
      }

      if (this.form.budget) {
        notes += `Budget: ${this.budgets[this.form.budget - 1].name}, `
      }
      if (this.form.planing_stage) {
        notes += `Planing Stage: ${this.form.planing_stage.replace('-', ' ')}, `
      }

      if (this.boat?.name) {
        notes += `Boat: ${this.boat.name}, `
      }

      if (this.marina && !this.marina.name) {
        notes += `From page: ${this.marina}, `
      }

      if (this.marina?.name) {
        notes += `Marina: ${this.marina.name}, `
      }

      if (this.form.flexibility) {
        notes += `Flexibility: ${this.form.flexibility}, `
      }

      if (form.charter_type) {
        const charter = this.getCharterTypesDefault.find(c => c.id === form.charter_type)
        notes += `Charter type: ${charter.name}, `
      }

      if (form.boat_type) {
        const boatType = this.getBoatTypes.find(b => b.id === form.boat_type)
        const trans = boatType.values?.find(v => v.language?.shortcode === 'en')
        if (trans) {
          notes += `Type of boat: ${trans.name}, `
        } else {
          notes += `Type of boat: ${boatType.untranslatedName}, `
        }
      }

      if (form.location) {
        notes += `Location: ${form.location}, `
      }

      if (form.comment) {
        notes += `Comment: ${form.comment}, `
      }

      if (this.ipInfo?.ip) {
        notes += `Customer IP: ${this.ipInfo.ip}, `
      }

      if (this.UTM?.utm_campaign && this.UTM?.utm_source) {
        notes += `UTM source/medium/campaign: ${this.UTM.utm_source} / ${this.UTM.utm_medium} / ${this.UTM.utm_campaign}, `
      }

      if (this.GCLID && this.GCLID !== '') {
        notes += `Google AD gclid/gbraid: ${this.GCLID} / ${this.GBRAID}, `
      } else if (gclid && gclid !== '') {
        notes += `Google AD gclid/gbraid: ${gclid} / ${gbraid}, `
      }

      notes = `Notes: ${notes}`
      const dst = dayjs().day(6).add(7, 'd').toDate()
      const den = dayjs().day(6).add(14, 'd').toDate()

      const request = {
        boat_id: this.boat?.id || null,
        first_name: form.first_name,
        last_name: form.last_name,
        start_date: form.date[0] ? this.formatDate(form.date[0],'YYYY-MM-DD') : this.formatDate(dst, 'YYYY-MM-DD'),
        end_date: form.date[1] ? this.formatDate(form.date[1],'YYYY-MM-DD') : this.formatDate(den, 'YYYY-MM-DD'),
        phone: form.phone_number.toString().trim().replace(/\s/g, ''),
        correspondence_language_id: this.user?.correspondence_language_id || 1,
        language: this.locale,
        planing_stage: form.planing_stage,
        email: form.email,
        guests: form.guests,
        skipper: false,
        notes,
        comment: form.comment,
        notify_agent: true,
        location: form.location,
        skip_availability: this.skipAvailability
      }

      this.$axios.post('/api/proposals/create-from-boat', request)
        .then(() => {
          this.busy.form = false
          this.$refs.formObs.reset()
          this.form.reset()
          this.$toast.success(this.$t('submitted'))
          this.$emit('saved')
          this.gtm[gtm.method](gtm.data)

          if (isWindow()) {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              event: 'Offer Request',
              eventCategory: 'Offer Request',
              eventAction: 'Submit offer',
              email: form.email,
              eventLabel: 'Proposal requested'
            })
          }
        })
        .catch((error) => {
          const msg = error.response?.data?.message
          vLog(this, error)
          this.busy.form = false
          this.$toast.error(this.$t('error') + (msg ? ' ' + this.$t(msg) : ''))
        })

      if (['request-offer'].includes(this.$route.name)) {
        this.$scrollTo({ y: 0 })
      }
    }
  }
}
